import hbgjAPI from './hbgj-api'
import hosts from '../hosts'

/* example
request.defray({
  auth: 'yes',
  url: '/api-pay/gateway.do',
  data: {
    pid: 500330,
    expireMinute: 30,
    payOrderId: res.bd.data.payId,
    origin: 'web',
    successPage: 'https://wtest.133.cn/dev/liuzihao/hangban/vue/insurance/insure?insurType=2'
  },
  sidFields: ['uid', 'pid', 'payOrderId', 'origin']
}).then(({ res }) => {
  location.href = `https://wtest.133.cn/hangban/h5pay?iToken=${res.bd.data.token}`
})
*/

export default function(options) {
  return hbgjAPI.getCommonParams().then(commonParams => {
    let data = Object.assign(
      {},
      commonParams,
      options.data
    )

    if (options.sidFields && options.sidFields.length > 0) {
      data.sid = hbgjAPI.generateSid(options.sidFields, data)
    }

    let headers = Object.assign({
      'content-type': 'application/x-www-form-urlencoded'
    }, options.headers)

    return {
      url: hosts.defray + options.url,
      method: options.method || 'POST',
      headers,
      data
    }
  })
}



// WEBPACK FOOTER //
// ./src/request/transformers/defray.js